'use client';

import { createContext } from 'react';
import type { PaletteKey, Tokens } from '../tokens/types';
import { bravemoveTokens } from '../bravemoveTokens';

export interface ThemeContextValue {
  readonly tokens: Tokens;
  readonly palette: PaletteKey;
  readonly setPalette: (key: PaletteKey) => void;
}

const defaultPalette: PaletteKey = 'garnet_light';

export const ThemeContext = createContext<ThemeContextValue>({
  tokens: bravemoveTokens(defaultPalette),
  palette: defaultPalette,
  setPalette: () => undefined,
});
